let getApi = () => import('@/services/Api');
const state = {
    dialog: false,
    passwordDialog: false,
    table: '',
    params: {},
    mutated: null,
    initial: null,
    dialogReadyCounter: 0
};

const getters = {
    getDialog: state => state.dialog,
    getPasswordDialog: state => state.passwordDialog,
    getDialogTable: (state, getters, rootState, rootGetters) => state.table || rootGetters.getCurrentTableName,
    getDialogAction: state => state.params.action,
    getDialogParams: state => state.params,
    getDialogHeaders: (state, getters, rootState, rootGetters) => {
        return rootGetters.getTableHeaderByName(getters.getDialogTable);
    },
    getMutated: state => state.mutated,
    getMutatedField: state => (fieldCode) => (state.mutated && state.mutated[fieldCode]) ? state.mutated[fieldCode] : null,
    getInitial: state => state.initial,
    getDialogReadyCounter: state => state.dialogReadyCounter
}
const actions = {
    async storeDialog({commit, getters}, payload) {
        if (payload.val === true) {
            let params = getters.getDialogParams;
            let fields = getters.getDialogHeaders;
            let initItem = {};
            if (params && params.action === 'edit') {
                let {http} = await getApi();
                //практика показала что лучше перезапросить редактируюмую запись
                const response = await http.getData(`view/${getters.getDialogTable}`, {
                    where: [{value: 'id', text: params.editedItemId}]
                });
                if (response.data.tabRows && response.data.tabRows[0]) {
                    initItem = response.data.tabRows[0]
                }
            }
            fields.forEach(function (field) {
                if (!initItem[field.value] || !initItem.hasOwnProperty(field.value)) {
                    initItem[field.value] = "";
                    if (field.type === 'REF') {
                        initItem[field.value] = {table: field.table};
                    }
                    if (field.type === 'ML') {
                        initItem[field.value] = {table: field.table, kaz: '', rus: '', eng: ''};
                    }
                }
            });
            commit('setInitial', initItem);
            commit('setMutated', JSON.parse(JSON.stringify(initItem)));
        }
        commit('setFilter', false)
        commit('setDialog', payload.val);
    },
    storePasswordDialog({commit}, payload) {
        commit('setPasswordDialog', payload.val);
    },
    storeDialogChangedItem({dispatch, commit, getters}, payload) {
        //если изменяли запись из представления таблицы, обновим стейт таблицы,
        const {initiator, index} = getters.getDialogParams;
        if (initiator === 'tableView') {
            dispatch('pushIntoTableRows', {item: payload.item, index: index}, {root: true});
        }
        commit('setDialogReadyCounter');
    },
    storeDialogTable({dispatch, commit}, payload) {
        const table = payload.table;
        dispatch('storeTabHeader', {table: table}, {root: true});
        commit('setDialogTable', table);
    },
    storeDialogParams({commit}, payload) {
        commit('setDialogParams', payload);
    },

    storeMutated({commit}, payload) {
        commit('setMutated', payload);
    },
    storeMutatedField({getters}, payload) {
        let obj = getters.getMutated;
        obj[payload.field] = payload.value
        //commit('setMutated', obj);
    },
}

const mutations = {
    setDialog(state, val) {
        state.dialog = val
    },
    setPasswordDialog(state, val) {
        state.passwordDialog = val
    },
    setDialogTable(state, item) {
        state.table = item
    },
    setDialogParams(state, item) {
        state.params = item
    },
    setMutated(state, val) {
        state.mutated = val
    },

    setInitial(state, val) {
        state.initial = val
    },
    setDialogReadyCounter(state) {
        state.dialogReadyCounter++
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}